export const HERO = {
  brand: 'Family Tree Maker',
  headline: 'Install the latest version of Family Tree Maker',
  support:
    'Get the newest features, bug fixes, and Ancestry tools for your family trees. The update usually takes a few minutes.',
  bullets: [
    'Improved charts, reports, and TreeVault',
    'Better Ancestry and FamilySearch connections',
    'Recommended fixes for common install issues',
  ],
  cta: 'Update Now',
};

export const UPDATE_STATUSES = [
  'Connecting to the update server…',
  'Checking your Family Tree Maker license…',
  'Downloading the main program files…',
  'Downloading media and library tools…',
  'Downloading Ancestry sync files…',
  'Downloading TreeVault components…',
  'Checking your computer settings…',
  'Saving a copy of your current preferences…',
  'Unpacking the update files…',
  'Installing Family Tree Maker…',
  'Updating charts and reports…',
  'Updating FamilySearch tools…',
  'Installing the latest fixes…',
  'Updating search and tree indexes…',
  'Checking photo and media folders…',
  'Setting up program services…',
  'Removing temporary files…',
  'Checking that the install finished…',
  'Saving update details…',
  'Finishing Family Tree Maker setup…',
  'Installing the last few files…',
  'Confirming the new version…',
  'Updating shortcuts…',
  'Almost finished…',
  'Running a final check…',
  'Closing the download…',
  'Refreshing program settings…',
  'Family Tree Maker is nearly ready…',
  'Wrapping up the update…',
  'Opening the completion screen…',
];

export const COMPLETE = {
  title: 'Your update is finished',
  lead:
    'Family Tree Maker is up to date. You can open the program and continue with your family trees.',
  tips: [
    'Open Family Tree Maker from your desktop or Start menu.',
    'Sign in to Ancestry again if you use sync.',
    'Make a new backup of your main tree after you open it once.',
  ],
  contactTitle: 'Need help?',
  contactBody:
    'If something went wrong, the program will not open, or you see an error, contact us and we will help you.',
};
